import { useState, useEffect } from "react";

export const useHeaderHeight = () => {
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const updateHeaderHeight = () => {
      const headerElement = document.querySelector(
        "[data-header-container]"
      ) as HTMLElement;
      if (headerElement) {
        setHeaderHeight(headerElement.offsetHeight);
      }
    };

    // Initial measurement
    updateHeaderHeight();

    // Update on window resize
    window.addEventListener("resize", updateHeaderHeight);

    // Update on status bar visibility changes
    const resizeObserver = new ResizeObserver(updateHeaderHeight);
    const headerElement = document.querySelector(
      "[data-header-container]"
    ) as HTMLElement;
    if (headerElement) {
      resizeObserver.observe(headerElement);
    }

    return () => {
      window.removeEventListener("resize", updateHeaderHeight);
      resizeObserver.disconnect();
    };
  }, []);

  return headerHeight;
};
